module.exports = __webpack_public_path__ + "525c34c8283f605753506b7df49fabfb.png";